import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../store/index'
// 路由懒加载  但是测试环境还是用正常加载  懒加载会导致webpack热更新比较慢
const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)
// 页面路由
/**
 * meta
 *  name 菜单显示名称
 *  hidden 为true时不显示菜单
 *  title 显示二级菜单列表时候使用
 *  imgSrc 显示二级菜单列表时候使用
 *  content 显示二级菜单列表时候使用
 *  hidden 为true时不显示菜单
 *  toLink 直接跳转的菜单 值为对应路由
 *  */
// 控制路由

const pageList = [
  {
    path: 'homePage',
    name: 'homePage',
    component: _import('views/homePage/index')
  },

  {
    path: 'read',
    name: 'read',
    component: _import('views/read/index')
  },
  {
    path: 'detail',
    name: 'detail',
    component: _import('views/detail/index')
  },
  {
    path: 'projectList',
    name: 'projectList',
    component: _import('views/projectList/index')
  },
  {
    path: 'aboutUs',
    name: 'aboutUs',
    component: _import('views/aboutUs/index')
  },
  {
    path: 'contactUs',
    name: 'contactUs',
    component: _import('views/contactUs/index')
  }

  // {
  //   path: 'projectDetail',
  //   name: 'projectDetail',
  //   component: _import('views/project/projectDetail')
  // },
  // {
  //   path: 'clientDetail',
  //   name: 'clientDetail',
  //   component: _import('views/client/clientDetail')
  // },
  // {
  //   path: 'solution',
  //   name: 'solution',
  //   component: _import('views/solution/index')
  // },
  // // 客户
  // {
  //   path: 'client',
  //   name: 'client',
  //   component: _import('views/client/index')
  // },
  // {
  //   path: 'showAll',
  //   name: 'showAll',
  //   component: _import('views/client/showAll')
  // },
  // {
  //   path: 'aboutUs',
  //   name: 'aboutUs',
  //   component: _import('views/aboutUs/index')
  // }
]
const routerList = {
  routes: [
    {
      path: '/',
      redirect: '/home/homePage'
    },
    // {
    //   path: '/test',
    //   component: _import('views/test/index')
    // },
    {
      path: '/404',
      component: _import('views/404/index')
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: _import('views/introduce/index')
    },
    // {
    //   path: '/test',
    //   component: _import('views/test/index')
    // },
    // 所有菜单路由放到home下
    {
      path: '/home',
      component: _import('home'),
      redirect: '/home/homePage',
      meta: { title: '' },
      children: [...pageList]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
}

const router = new Router(routerList)
router.beforeEach((to, from, next) => {
  if (to.name != 'projectList') {
    window.scrollTo(0, 0)
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  if (Object.keys(store.getters.pageData).length) {
    next()
  } else {
    axios.get('./static/data.json').then(res => {
      store.commit('setPageData', res.data)
      next()
    })
  }
})
// router.beforeEach((to, form, next) => {
//   //   if (!getToken()) {
//   //     login().then(res => {
//   //       setToken(res.data.token)
//   //       next()
//   //     })
//   //   } else {
//   next()
//   //   }
// })
export default router
export { pageList }



// WEBPACK FOOTER //
// ./src/router/index.js